import { createModel } from "@/orm/model";
import { BelongsToIds, EntityRecord, belongsToIds } from "@/orm/types";
import { OrganizationRecord } from "./organization";
import { Tag } from "./tag";
import { getUserDefaultRecordId } from "./user";

export type DealDirectoryRecord = EntityRecord & {
  progressStatusTags: Tag[];
  belongsToOranizationIds: BelongsToIds<OrganizationRecord>;
};

export const dealDirectoryModel = createModel<DealDirectoryRecord>({
  version: "1.0",
  collectionPath: "modelEntityRecordDealDirectory",
  labels: {
    singular: "Deal Tracker",
    plural: "Deal Trackers",
  },
  getDefaultRecord: () => ({
    belongsToOranizationIds: belongsToIds([]),
    progressStatusTags: [
      { id: "new", label: "New", paletteId: "sunnyYellow" },
      { id: "working", label: "Working", paletteId: "lavender" },
      { id: "due-diligence", label: "Due Diligence", paletteId: "royalBlue" },
      { id: "ioi-loi", label: "IOI/LOI", paletteId: "limeGreen" },
      { id: "archived", label: "Archived", paletteId: "midnightBlue" },
    ],
  }),
});

export const getDefaultDealDirectoryEntity = () => {
  return dealDirectoryModel.createEntityInstance({
    id: getUserDefaultRecordId(),
  });
};
